'use strict';
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line: max-func-body-length
function speechMarkdownGrammar(myna) {
    var m = myna;
    // Override parenthesis function to not use `.guardedSeq`
    // This sequence is too assertive, and may cause exceptions rather than just returning null
    m.parenthesized = function (rule) {
        return m.seq('(', m.ws, rule, m.ws, ')').setType('parenthesized');
    };
    // tslint:disable-next-line: typedef
    // tslint:disable-next-line: max-func-body-length
    var g = new (function () {
        //         // Allows the "inline" to be referenced before it is defined.
        //         // This enables recursive definitions.
        //         this.inlineDelayed = m.delay(() => this.inline);
        //         this.boundedInline = function(begin: any, end: any) : any {
        // // tslint:disable-next-line: no-parameter-reassignment
        //             if (end === undefined) { end = begin; }
        //             return m.seq(begin, this.inlineDelayed.unless(end).zeroOrMore, end);
        //         }
        // Plain text
        var specialCharSet = '[]()';
        var specialCharSetEmphasis = '[]()*~`@#\\_!+-';
        var ws = m.char(' \t').oneOrMore;
        var optWs = ws.opt;
        var wsOrNewLine = ws.or(m.newLine);
        var nonSpecialChar = m.notChar(specialCharSetEmphasis).unless(m.newLine);
        var nonSpecialCharEmphasis = m.notChar(specialCharSet).unless(m.newLine);
        var quoteChar = m.notChar('"');
        /*
         xsd:token - XML Schema2 section 3.3.2
         token represents tokenized strings.
         The ·value space· of token is the set of strings that do not contain the
         carriage return (#xD), line feed (#xA) nor tab (#x9) characters, that have
         no leading or trailing spaces (#x20) and that have no internal sequences
         of two or more spaces. The ·lexical space· of token is the set of strings
         that do not contain the carriage return (#xD), line feed (#xA) nor
         tab (#x9) characters, that have no leading or trailing spaces (#x20) and
         that have no internal sequences of two or more spaces.
    
         This implementation plays very loose with the definition.
         */
        this.xsdToken = m.choice(m.digits, m.letters, m.char(specialCharSetEmphasis)).oneOrMore.ast;
        this.plainText = m.choice(m.digits, m.letters, ws, nonSpecialChar).oneOrMore.ast;
        this.plainTextEmphasis = m.choice(m.digits, m.letters, ws, nonSpecialChar).oneOrMore.ast;
        var plainTextChoice = m.choice(m.digits, m.letters, ws, nonSpecialCharEmphasis);
        this.plainTextModifier = plainTextChoice.oneOrMore.ast;
        this.plainTextPhone = m.seq(m.parenthesized(m.digits), plainTextChoice.oneOrMore).ast;
        this.plainTextSpecialChars = m.choice(m.seq('(', plainTextChoice, ') '), m.seq('[', plainTextChoice, '] '), m.choice.apply(m, specialCharSetEmphasis.split('')).oneOrMore).oneOrMore.ast;
        // Audio
        this.urlSpecialChar = m.char(':/.-_~?#[]@!+,;%=()&');
        this.url = m.choice(m.digit, m.letter, this.urlSpecialChar).oneOrMore.ast;
        this.audio = m.seq('![', m.choice(m.singleQuoted(this.url), m.doubleQuoted(this.url)), ']').ast;
        // Break
        this.timeUnit = m.choice('s', 'ms').ast;
        this.fraction = m.seq('.', m.digit.zeroOrMore);
        this.number = m.seq(m.integer, this.fraction.opt).ast;
        this.time = m.seq(this.number, this.timeUnit).ast;
        this.shortBreak = m.seq('[', this.time, ']').ast;
        // Silence
        this.silenceTypeValue = m.choice('Leading', 'Tailing', 'Sentenceboundary').ast;
        this.silenceData = m.seq(this.silenceTypeValue, ' ', this.time).ast;
        this.silence = m.seq('[', 'silence', ':', m.choice(m.singleQuoted(this.silenceData), m.doubleQuoted(this.silenceData)), ']').ast;
        // Backgroundaudio
        this.backgroundData = m.seq(' ', this.url);
        this.backgroundAudio = m.seq('[', 'backgroundaudio', ':', m.choice(m.singleQuoted(m.seq(this.url, this.backgroundData.zeroOrMore).ast), m.doubleQuoted(m.seq(this.url, this.backgroundData.zeroOrMore).ast)), ']').ast;
        // Lexicon
        this.lexicon = m.seq('[', 'lexicon', ':', m.choice(m.singleQuoted(this.url), m.doubleQuoted(this.url)), ']').ast;
        // Bookmark
        this.bookmarkChar = m.char('.-_');
        this.bookmarkString = m.choice(m.digit, m.letter, this.bookmarkChar).oneOrMore.ast;
        this.bookmark = m.seq('[', 'bookmark', ':', m.choice(m.singleQuoted(this.bookmarkString), m.doubleQuoted(this.bookmarkString)), ']').ast;
        // this.string = m.choice(m.doubleQuotedString(), m.singleQuotedString()).ast;
        // Emphasis
        // The emphasis tag should be preluded and followed by a not-letter-character.
        // Otherwise an example like above would be captured.
        var notLetterChar = m.not(m.letters);
        this.shortEmphasisModerate = m.seq(notLetterChar, '+', this.plainTextEmphasis, '+', notLetterChar).ast;
        this.shortEmphasisStrong = m.seq(notLetterChar, '++', this.plainTextEmphasis, '++', notLetterChar).ast;
        this.shortEmphasisNone = m.seq(notLetterChar, '~', this.plainTextEmphasis, '~', notLetterChar).ast;
        this.shortEmphasisReduced = m.seq(notLetterChar, '-', this.plainTextEmphasis, '-', notLetterChar).ast;
        this.emphasis = m.choice(this.shortEmphasisModerate, this.shortEmphasisStrong, this.shortEmphasisNone, this.shortEmphasisReduced);
        // Modifier
        // (text)[key] or (text)[key;]
        // (text)[key:'value'] or (text)[key:'value';]
        // (text)[key: "value"] or (text)[key: "value";]
        // (text)[key:'value';key;key:"value"]
        var colon = m.char(':').ws;
        var semicolon = m.char(';').ws;
        this.textModifierKey = m.keywords('emphasis', 'address', 'number', 'cardinal', 'characters', 'chars', 'digits', 'drc', 'expletive', 'bleep', 'fraction', 'interjection', 'ordinal', 'telephone', 'phone', 'unit', 'time', 'date', 'whisper', 'ipa', 'sapi', 'ups', 'sub', 'vol', 'volume', 'rate', 'pitch', 'contour', 'range', 'timbre', 'lang', 'voice', 'excited', 'disappointed', 'emotion', 'paragraph', 'sentence').ast;
        // Special characters for <phoneme alphabet="ipa" ph="..."> tag
        var ipaPulmonicConsonants = [
            // Plosive
            'p',
            'b',
            't',
            'd',
            'ʈ',
            'ɖ',
            'c',
            'ɟ',
            'k',
            'ɡ',
            'g',
            'q',
            'ɢ',
            'ʔ',
            // Nasal
            'm',
            'ɱ',
            'n',
            'ɳ',
            'ɲ',
            'ŋ',
            'ɴ',
            // Trill
            'ʙ',
            'r',
            'ʀ',
            // Tap or Flap
            'ⱱ',
            'ɾ',
            'ɽ',
            // Fricative
            'ɸ',
            'β',
            'f',
            'v',
            'θ',
            'ð',
            's',
            'z',
            'ʃ',
            'ʒ',
            'ʂ',
            'ʐ',
            'ç',
            'ʝ',
            'x',
            'ɣ',
            'χ',
            'ʁ',
            'ħ',
            'ʕ',
            'h',
            'ɦ',
            // Lateral fricative
            'ɬ',
            'ɮ',
            // Approximant
            'ʋ',
            'ɹ',
            'ɻ',
            'j',
            'ɰ',
            // Lateral approximant
            'l',
            'ɭ',
            'ʎ',
            'ʟ'
        ];
        var ipaNonPulmonicConsonants = [
            // Clicks
            'ʘ',
            'ǀ',
            'ǃ',
            'ǂ',
            'ǁ',
            // Voiced implosive
            'ɓ',
            'ɗ',
            'ʄ',
            'ɠ',
            'ʛ',
            // Ejectives (already existing chars + unicode char \u02BC)
            'ʼ'
        ];
        var ipaVowels = [
            // Close
            'i',
            'y',
            'ɨ',
            'ʉ',
            'ɯ',
            'u',
            'ɪ',
            'ʏ',
            'ʊ',
            // Close-mid
            'e',
            'ø',
            'ɘ',
            'ɚ',
            'ɵ',
            'ɤ',
            'o',
            'ə',
            // Open-mid
            'ɛ',
            'œ',
            'ɜ',
            'ɝ',
            'ɞ',
            'ʌ',
            'ɔ',
            'æ',
            'ɐ',
            // Open
            'a',
            'ɶ',
            'ɑ',
            'ɒ'
        ];
        var ipaOtherSymbols = [
            'ʍ',
            'w',
            'ɥ',
            'ʜ',
            'ʢ',
            'ʡ',
            'ɕ',
            'ʑ',
            'ɺ',
            'ɧ',
            '\u0361',
            '\u035C' // char ͜
        ];
        var ipaDiacritics = [
            '\u0325',
            '\u030A',
            '\u032C',
            'ʰ',
            '\u0339',
            '\u031C',
            '\u031F',
            '\u0320',
            '\u0308',
            '\u033D',
            '\u0329',
            '\u032F',
            '\u02DE',
            '\u0324',
            '\u0330',
            '\u033C',
            'ʷ',
            'ʲ',
            'ˠ',
            'ˤ',
            '\u0334',
            '\u031D',
            '\u031E',
            '\u0318',
            '\u0319',
            '\u032A',
            '\u033A',
            '\u033B',
            '\u0303',
            'ⁿ',
            'ˡ',
            '\u031A',
        ];
        var ipaSupraSegmentals = [
            'ˈ',
            'ˌ',
            'ː',
            'ˑ',
            '\u0306',
            '|',
            '‖',
            '.',
            '‿'
        ];
        var ipaTones = [
            '\u030B',
            '\u0301',
            '\u0304',
            '\u0300',
            '\u030F',
            '↓',
            '↑',
            '↗',
            '↘',
            '\u030C',
            '\u0302'
        ];
        var unicodeBlendedCharacters = [
            'à', 'è', 'ì', 'ò', 'ù', 'À', 'È', 'Ì', 'Ò', 'Ù',
            'á', 'é', 'í', 'ó', 'ú', 'ý', 'Á', 'É', 'Í', 'Ó', 'Ú', 'Ý',
            'â', 'ê', 'î', 'ô', 'û', 'Â', 'Ê', 'Î', 'Ô', 'Û',
            'ä', 'ë', 'ï', 'ö', 'ü', 'ÿ', 'Ä', 'Ë', 'Ï', 'Ö', 'Ü', 'Ÿ',
            'ã', 'ñ', 'õ', 'Ã', 'Ñ', 'Õ',
            'å', 'Å'
        ];
        var ipaOtherCharacters = [
            'ɩ',
            'ɫ',
            'ɷ',
            'ɼ',
            'ɿ',
            'ʅ',
            'ʆ',
            'ʇ',
            'ʓ',
            'ʖ',
            'ʗ',
            'ʚ',
            'ʞ',
            'ʠ',
            'ʣ',
            'ʤ',
            'ʥ',
            'ʦ',
            'ʧ',
            'ʨ',
            'ʩ',
            'ʪ',
            'ʫ',
            'ʬ',
            'ʭ',
            'ʮ',
            'ʯ'
        ];
        var ipaChars = __spreadArrays(ipaPulmonicConsonants, ipaNonPulmonicConsonants, ipaVowels, ipaOtherSymbols, ipaDiacritics, ipaSupraSegmentals, ipaTones, unicodeBlendedCharacters, ipaOtherCharacters);
        var percentChange = [
            '+',
            m.hyphen,
            m.digit,
            '%',
        ];
        this.textModifierText = m.choice.apply(m, __spreadArrays([m.digit,
            m.letter,
            m.hyphen,
            m.space], ipaChars, percentChange)).oneOrMore.ast;
        this.textModifierTextDoubleQuote = m.choice.apply(m, __spreadArrays([m.digit,
            m.letter,
            m.hyphen,
            m.space], ipaChars, percentChange, ["'"])).oneOrMore.ast;
        this.textModifierValue = m.seq(colon, m.choice(m.singleQuoted(this.textModifierText), m.doubleQuoted(this.textModifierTextDoubleQuote)));
        this.textModifierKeyOptionalValue = m.seq(this.textModifierKey, this.textModifierValue.opt).ast;
        this.modifier = m.bracketed(m.delimited(this.textModifierKeyOptionalValue.ws, semicolon));
        var textText = m.parenthesized(this.plainTextModifier);
        var textTextPhone = m.parenthesized(this.plainTextPhone);
        this.textModifier = m.seq(m.choice(textText, textTextPhone), this.modifier).ast;
        // Section
        this.sectionModifierKey = m.keywords('lang', 'voice', 'defaults', 'dj', 'newscaster', 'excited', 'disappointed').ast;
        this.sectionModifierText = m.choice(m.digit, m.letter, m.hyphen).oneOrMore.ast;
        this.sectionModifierValue = m.seq(colon, m.choice(m.singleQuoted(this.sectionModifierText), m.doubleQuoted(this.sectionModifierText)));
        this.sectionModifierKeyOptionalValue = m.seq(this.sectionModifierKey, this.sectionModifierValue.opt).ast;
        this.sectionModifier = m.bracketed(m.delimited(this.sectionModifierKeyOptionalValue.ws, semicolon));
        this.section = m.seq('#', this.sectionModifier).ast;
        // values
        this.valueNone = 'none';
        this.valueXWeak = 'x-weak';
        this.valueWeak = 'weak';
        this.valueMedium = 'medium';
        this.valueStrong = 'strong';
        this.valueXStrong = 'x-strong';
        this.breakStrengthValue = m.keywords(this.valueNone, this.valueXWeak, this.valueWeak, this.valueMedium, this.valueStrong, this.valueXStrong).ast;
        this.breakValue = m.choice(this.breakStrengthValue, this.time).ast;
        this.break = m.seq('[', 'break', ':', m.choice(m.singleQuoted(this.breakValue), m.doubleQuoted(this.breakValue)), ']').ast;
        this.markTag = m.seq('[', 'mark', ':', m.choice(m.singleQuoted(this.xsdToken), m.doubleQuoted(this.xsdToken)), ']').ast;
        this.any = m.advance;
        this.inline = m
            .choice(this.backgroundAudio, this.lexicon, this.bookmark, this.textModifier, this.emphasis, this.shortBreak, this.silence, this.break, this.audio, this.markTag, this.plainTextSpecialChars, this.plainText, this.any)
            .unless(m.newLine);
        this.lineEnd = m.newLine.or(m.assert(m.end)).ast;
        this.emptyLine = m.char(' \t').zeroOrMore.then(m.newLine).ast;
        this.restOfLine = m.seq(this.inline.zeroOrMore).then(this.lineEnd);
        this.simpleLine = m.seq(this.emptyLine.not, m.notEnd, this.restOfLine).ast;
        this.paragraph = this.simpleLine.oneOrMore.ast;
        this.content = m.choice(this.section, this.paragraph, this.emptyLine);
        this.document = this.content.zeroOrMore.ast;
    })();
    // Register the grammar, providing a name and the default parse rule
    return m.registerGrammar('speechmarkdown', g, g.document);
}
exports.speechMarkdownGrammar = speechMarkdownGrammar;
//# sourceMappingURL=SpeechMarkdownGrammar.js.map